module.exports = {"fg":{"coilType":"Coil Type","pipeMaterial":"Pipe Material","pipeSize":"Pipe Size","coating":"Coating/Paint","drawingNo":"Drawing No.","objectType":"Object Type","drawingRev":"Drawing REV","tubeMaterial":"Material Tube","type":"TUBE Size","pattern":"Pattern","year":"Year","runNo":"Run No.","coilObject":"Coil Objective","rev":"Revision","sites":"Sites","layer":"Layer","tubeHeight":"Tube High"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/fg.json
// module id = 915
// module chunks = 108